var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return (() => {}).apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "1200px",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("FormHeader", {
                        attrs: {
                          loading: _vm.loading,
                          link: "page-seo-configs",
                          title: _vm.data.name
                            ? `${_vm.data.name} конфигурация seo`
                            : `Создать конфигурацию seo`,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "PageContent",
                        { attrs: { height: "85" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Имя * ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          id: "name",
                                          outlined: "",
                                          disabled: _vm.loading,
                                          "error-messages":
                                            _vm.validationErrors.name,
                                        },
                                        model: {
                                          value: _vm.fields.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.fields, "name", $$v)
                                          },
                                          expression: "fields.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("span", [_vm._v("Ключ *")]),
                                      _c("v-text-field", {
                                        attrs: {
                                          id: "key",
                                          outlined: "",
                                          disabled: _vm.loading,
                                          "error-messages":
                                            _vm.validationErrors.key,
                                        },
                                        model: {
                                          value: _vm.fields.key,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.fields, "key", $$v)
                                          },
                                          expression: "fields.key",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Meta title ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          disabled: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.seoMetaTitle,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "seoMetaTitle",
                                              $$v
                                            )
                                          },
                                          expression: "fields.seoMetaTitle",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Description ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          disabled: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.seoMetaDescription,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "seoMetaDescription",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fields.seoMetaDescription",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Keywords ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          disabled: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.seoMetaKeywords,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "seoMetaKeywords",
                                              $$v
                                            )
                                          },
                                          expression: "fields.seoMetaKeywords",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("span", [
                                        _vm._v("SEO disallow index"),
                                      ]),
                                      _c("v-switch", {
                                        attrs: {
                                          inset: "",
                                          dense: "",
                                          disabled: _vm.loading,
                                          loading: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.seoDisallowIndex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "seoDisallowIndex",
                                              $$v
                                            )
                                          },
                                          expression: "fields.seoDisallowIndex",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("span", [_vm._v("Rel canonical")]),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          disabled: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.seoRelCanonical,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.fields,
                                              "seoRelCanonical",
                                              $$v
                                            )
                                          },
                                          expression: "fields.seoRelCanonical",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("span", [_vm._v("SEO image")]),
                                      _c("MediaFilePicker", {
                                        attrs: {
                                          multiple: false,
                                          "file-type":
                                            _vm.$options.mediaTypesByKeys.IMAGE,
                                          value: _vm.fields.seoOgImageId,
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.fields.seoOgImageId = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("ManageSidePanel", {
                ref: "manageSidePanel",
                attrs: {
                  "is-new": !_vm.data.id,
                  "created-at": _vm.data.createdAt,
                  "updated-at": _vm.data.updatedAt,
                  "is-loading": _vm.loading,
                  language: _vm.language,
                  translations: _vm.fields.translations,
                },
                on: {
                  submit: _vm.submit,
                  delete: function ($event) {
                    return _vm.$emit("delete-seo-config")
                  },
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-seo-configs" })
                  },
                  "update-translations": function ($event) {
                    return Object.assign(_vm.fields.translations, $event)
                  },
                  "language-update": function ($event) {
                    return _vm.$emit("language-update", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }